export default __webpack_public_path__ + "static/media/locksmith.813099ff.svg";